import type { QueryClient } from '@tanstack/react-query'

export function invalidateSessionListAndCoinBalance(
  queryClient: QueryClient,
  sessionQueryRootKey: string,
  coinBalanceQueryKey: readonly unknown[],
) {
  void queryClient.invalidateQueries({ queryKey: [sessionQueryRootKey] })
  void queryClient.invalidateQueries({ queryKey: coinBalanceQueryKey })
}
